import React from "react";
import {Box, Stack, Typography} from "@mui/material";

// Flat input control - replaces MUI TextField's outlined/floating-label look. Pair with labelSx
// above the field (see knowledge-manager/components/CreateTopicModalNew.js for the source pattern).
export const controlSx = {
  minHeight: 40, display: "flex", alignItems: "center", gap: 1, px: 1.25, borderRadius: "10px",
  bgcolor: "#FAFAFD", color: "#6B6B80", fontSize: 13,
};

export const labelSx = {
  fontSize: 12, fontWeight: 600, color: "#6B6B80", mb: 0.75, textTransform: "uppercase", letterSpacing: "0.05em",
};

export const selectMenuProps = {PaperProps: {sx: {borderRadius: "12px", mt: 0.5}}};

// Section icon badge + title + description, used at the top of each settings tab
export const SectionHeader = ({icon, title, description, action}) => (
  <Stack direction={{xs: "column", sm: "row"}} justifyContent={"space-between"} alignItems={"flex-start"} gap={1.5} sx={{mb: 2}}>
    <Stack direction={"row"} gap={1.5} alignItems={"flex-start"}>
      <Box sx={{
        display: "flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: "10px",
        flexShrink: 0, bgcolor: "rgba(132, 145, 247, 0.12)", color: "#8491F7",
      }}>
        {icon}
      </Box>
      <Box>
        <Typography sx={{fontSize: 15, fontWeight: 700, color: "#23264D"}}>{title}</Typography>
        {description && <Typography sx={{fontSize: 13, color: "#8A8AA0", mt: 0.25}}>{description}</Typography>}
      </Box>
    </Stack>
    {action && <Box sx={{flexShrink: 0, width: {xs: "100%", sm: "auto"}}}>{action}</Box>}
  </Stack>
);
